module.exports = __webpack_public_path__ + "static/media/sorbonne.88b86a79.jpg";